<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link
              :to="{
                path: `/Payment/PettycashPayment/` + this.fundReplenishment,
              }"
              v-has-permission="'CreateExpense'"
            >
              <vs-button class="bg_l_green">
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("CreatePettycashPayment") }}
              </vs-button>
            </router-link>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                {
                  title: $t('PayerAccount'),
                  sort: 'PayerAccount',
                },
                {
                  title: $t('PayerFloatingAccount'),
                  sort: 'PayerFloatingAccount',
                },
                { title: $t('ReceiverAccount'), sort: 'ReceiverAccount' },
                {
                  title: $t('ReceiverFloatingAccount'),
                  sort: 'ReceiverFloatingAccount',
                },
                { title: $t('Fee'), sort: 'Fee' },

                { title: $t('Description'), sort: 'Description' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action'), sort: 'Action' },
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  <div class="flex justify-center items-center flex-wrap">
                    {{
                      row.payerInfoQuery ? row.payerInfoQuery.accountName : ""
                    }}
                    &nbsp;
                    <div style="direction: ltr;text-wrap:nowrap;">
                      (
                      {{
                        row.payerInfoQuery
                          ? row.payerInfoQuery.accountCode
                          : ""
                      }} )
                    </div>
                  </div>
                </td>
                <td>
                  <div class="flex justify-center items-center flex-wrap" v-if="row.payerInfoQuery.floatingAccountName">
                    {{
                      row.payerInfoQuery
                        ? row.payerInfoQuery.floatingAccountName
                        : ""
                    }}
                    &nbsp;
                    <div style="direction: ltr;text-wrap:nowrap;">
                      (
                      {{
                        row.payerInfoQuery
                          ? row.payerInfoQuery.floatingAccountCode
                          : ""
                      }} )
                    </div>
                  </div>
                  <div v-else>-</div>
                </td>

                <td>
                  <div class="flex justify-center items-center flex-wrap">
                     {{
                    row.receiverInfoQuery
                      ? row.receiverInfoQuery.accountName
                      : ""
                  }}
                  &nbsp;
                  <div style="direction: ltr;text-wrap:nowrap;">
                    (
                    {{
                      row.receiverInfoQuery
                        ? row.receiverInfoQuery.accountCode
                        : ""
                    }} )
                  </div>
                  </div>
                 
                </td>
                <td>
                  <div class="flex justify-center items-center flex-wrap" v-if="row.receiverInfoQuery.floatingAccountName">
                    {{
                      row.receiverInfoQuery
                        ? row.receiverInfoQuery.floatingAccountName
                        : ""
                    }}
                    &nbsp;
                    <div style="direction: ltr;text-wrap:nowrap;">
                      (
                      {{
                        row.receiverInfoQuery
                          ? row.receiverInfoQuery.floatingAccountCode
                          : ""
                      }} )
                    </div>
                  </div>
                  <div v-else>-</div>
                </td>

                <td>{{ formatPrice(row.amount) }}</td>
                <td style="width: 15%">
                  {{ row.description ? row.description : "-" }}
                </td>
                <td>{{ row.createOn }}</td>
                <td>
                  <router-link
                    :to="{
                      path: '/PettyCash/PaymentDetails/' + row.id,
                    }"
                  >
                    <!-- query: {
                        payerDetails: row.receiverInfoQuery.floatingAccountName,
                      }, -->
                    <vs-button class="bg_l_green">
                      {{ $t("Details") }}
                    </vs-button>
                  </router-link>
                  <router-link
                  class="mr-5"
                    :to="{
                      path: '/PettyCash/PaymentAttachment/' + row.id,
                    }"
                    v-has-permission="permission117"
                  >
                    <!-- query: {
                        payerDetails: row.receiverInfoQuery.floatingAccountName,
                      }, -->
                    <vs-button class="bg_l_green">
                      {{ $t("Attachment") }}
                    </vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./PaymentPopup.vue";

import moment from "moment";
export default {
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission117: "GetAllFiles|AddFileAttachmentCommand",

      fundReplenishment: -1,
      ModifyPopup: false,
      modalModel: {},
      itemList: [],
      subsidiaryAccounts: [],
      gridDataSource: {
        type: "app",
        service: `Credits/api/PettyCashTransactionQuery/all-expense/by/${this.$route.params.id}`,
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  mounted() {
    this.fundReplenishment = this.$route.params.id;
  },
  methods: {
    ...mapActions({
      removeAccount: "floatingAccount/remove",
    }),
    ////Open Modal In Create Mode
    createAccount() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },

    //Open Modal In Edit Mode

    //Delete Method
    deleteAccount(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeAccount(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
